import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { KNOWLEDGE_BASE_PATH } from "../paths";

/**
 * Opens the Knowledge Base. Shown to every logged-in user, locally and in production (the Diagnostics view is for
 * everyone; changing knowledge is staff only).
 */
export default function KnowledgeBaseButton({ sx }) {
  const navigate = useNavigate();
  return (
    <Button
      variant="outlined"
      startIcon={<MenuBookIcon />}
      onClick={() => navigate(KNOWLEDGE_BASE_PATH)}
      sx={{ minHeight: 44, whiteSpace: "nowrap", lineHeight: 1.2, ...sx }}
    >
      Knowledge Base
    </Button>
  );
}
